<template>
<!-- 复制的wifi投放  store增加 isH5RealTime 传参 -->
  <div class="order">
    <div class="p-title">实时广告投放</div>
    <div class="p-main">
      <div class="put_tabs" v-show="!isShowConfirm">
        <span
          v-for="{ componentName, title, type } in tabItems"
          :class="['put_tab_pane', {'act': componentName === curTab}]"
          :key="componentName"
          @click="tabSelect(componentName, type)">
          {{ title }}
        </span>
      </div>
      <PutOrderRealTimeContainer v-if="showContent" @showConfirm="v => { isShowConfirm = v }"></PutOrderRealTimeContainer>
    </div>
  </div>
</template>

<script>
import PutOrderRealTimeContainer from './PutOrderRealTimeContainer'

export default {
  name: 'PutOrderRealTime',
  components: { PutOrderRealTimeContainer },
  data () {
    return {
      curTab: 'putOrder',
      tabItems: [
        {
          title: '条件搜索',
          componentName: 'putOrder'
        }, {
          title: '导入小区',
          componentName: 'communityImport'
        }, {
          title: '导入点位',
          componentName: 'deviceImport'
        }, {
          title: '订单复投',
          componentName: 'orderReput',
          type: 'orderReput'
        }
      ],
      isShowConfirm: false,
      showContent: true
    }
  },
  beforeDestroy () {
    this.$store.commit('order/setH5RealTime', 0) // 重置实时H5广告属性为false
    this.init()
  },
  async created () {
    if (!this.$store.state.common.advertTypes || !this.$store.state.common.advertTypes.length) {
      await this.$store.dispatch('getAdvertType')
    }

    this.$store.commit('order/setH5RealTime', 1) // 初始设置实时H5广告属性为true
    this.init()
  },
  methods: {
    init () {
      let { componentName, type } = this.tabItems[0]
      this.$store.commit('order/setCoditionSearchType', componentName || '') // 初始设置状态为条件筛选
      this.$store.commit('order/setData', { key: 'searchTabType', value: type || '' })
    },
    tabSelect (tabName, type) {
      if (tabName === this.curTab) return
      this.curTab = tabName
      this.$store.commit('order/setCoditionSearchType', tabName)
      this.$store.commit('order/setData', { key: 'searchTabType', value: type })
      this.showContent = false
      this.$nextTick(() => {
        this.showContent = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.put_tabs {
  height: 50px;
  padding: 0 10px;
  background-color: #f5f5f5;
  box-shadow: 0 -1px 0 0 #d4d4d4 inset;
}
.put_tab_pane {
  display: inline-block;
  padding: 9px 28px;
  margin-top: 8px;
  margin-left: 10px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  background-color: #F5F5F5;
  border: 1px solid #D4D4D4;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  &:hover {
    color: #000;
  }
  &.act {
    color: #282729;
    background-color: #FFFFFF;
    border-bottom-color: #fff;
    font-weight: bolder;
  }
}
</style>
